import { C1Icon } from 'components/core/icons/C1Icon'
import { Settings, User, UserCog } from 'lucide-react'
import React from 'react'
import { styles } from './styles'

type AppUserAccountTypeIconProps = {
    className?: string
    iconSize?: 'small' | 'inherit' | 'medium' | 'large'
}

const mapIconSize = (iconSize?: 'small' | 'inherit' | 'medium' | 'large'): 'sm' | 'md' | 'lg' | undefined => {
    switch (iconSize) {
        case 'small':
            return 'sm'
        case 'medium':
        case 'inherit':
            return 'md'
        case 'large':
            return 'lg'
        default:
            return undefined
    }
}

export const AppUserAccountTypeUserIcon = ({ className, iconSize }: AppUserAccountTypeIconProps): React.ReactElement => {
    return <C1Icon icon={User} className={className} sx={!className ? styles.icon : undefined} size={mapIconSize(iconSize)} />
}

export const AppUserAccountTypeServiceUserIcon = ({
    className,
    iconSize,
}: AppUserAccountTypeIconProps): React.ReactElement => {
    return <C1Icon icon={UserCog} className={className} sx={!className ? styles.icon : undefined} size={mapIconSize(iconSize)} />
}

export const AppUserAccountTypeSystemUserIcon = ({ className, iconSize }: AppUserAccountTypeIconProps): React.ReactElement => {
    return <C1Icon icon={Settings} className={className} sx={!className ? styles.icon : undefined} size={mapIconSize(iconSize)} />
}
